module.exports = __webpack_public_path__ + "static/slider03.ea2ed4b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/slider/slider03.jpg
// module id = 474
// module chunks = 263791100135453